'use client'

import { FC } from 'react'
import Image, { type ImageLoaderProps } from 'next/image'

import { strapiPublicImage } from 'utility/utility'
import type { Media } from '../UploadFile'

export const UploadFileImage: FC<Media> = ({
    url,
    mime,
    className,
    alternativeText,
    style,
    sizes = "(max-width: 768px) 100vw, 50vw",
    loading
}) =>
    <picture className={className}>
        <Image
            loader={ ({ src, width, quality }: ImageLoaderProps): string =>
                  `/api/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}`
            }
            src={strapiPublicImage(url)}
            alt={alternativeText ?? ''}
            style={{
                ...style,
                ...( mime === 'image/svg+xml' ? { objectFit: 'contain' } : {} )
            }}
            loading={ loading ?? 'lazy' }
            sizes={sizes}
            placeholder='blur'
        />
    </picture>
